// extracted by mini-css-extract-plugin
export default {"p_tye":"a4e88e03be","slcted":"_9b75355ce5","slc_color":"_77f0731718","item_p":"b814cace8a","r0":"_5a5bdeecfc"};